export default __webpack_public_path__ + "static/media/i hope i see you again.fca342f5.jpg";